import { defineAsyncComponent } from 'vue'
export default {
  barren: defineAsyncComponent(() => import("/root/front/layouts/barren.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/root/front/layouts/default.vue").then(m => m.default || m)),
  "onboarding-flow": defineAsyncComponent(() => import("/root/front/layouts/onboarding-flow.vue").then(m => m.default || m))
}